import { render, staticRenderFns } from "./ActionDatabaseManagement.vue?vue&type=template&id=5152bf3a&scoped=true&"
import script from "./ActionDatabaseManagement.vue?vue&type=script&lang=js&"
export * from "./ActionDatabaseManagement.vue?vue&type=script&lang=js&"
import style0 from "./ActionDatabaseManagement.vue?vue&type=style&index=0&id=5152bf3a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5152bf3a",
  null
  
)

export default component.exports